import { DialogRef } from '@angular/cdk/dialog'
import { Component, OnInit } from '@angular/core'
import { RoutingService } from '@spartacus/core'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { LaunchDialogService } from '@spartacus/storefront'

@Component({
    selector: 'app-restock-fees-no-modal',
    templateUrl: './restock-fees-no-modal.component.html',
    styleUrls: ['./restock-fees-no-modal.component.scss'],
    standalone: false
})
export class RestockFeesNoModalComponent implements OnInit {
  constructor(
    protected routingService: RoutingService,
    protected modalService: LaunchDialogService,
    private dialogRef: DialogRef<RestockFeesNoModalComponent>
  ) {}

  ngOnInit(): void {}
  closeModal(): void {
    // this.modalService.dismissActiveModal();
    this.dialogRef.close()
  }
}
